import { Card, Typography } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { HEAD_BRANCH_LIST_HEAD } from "../../variables/constants";
import { Link } from "react-router-dom";
import { FaRegSquareCheck } from "react-icons/fa6";
import { FaRegDotCircle } from "react-icons/fa";
import LoadingGif from "../../assets/loading_anim.gif";
import toast from "react-hot-toast";
import { getServices } from "../../apiServices/apiServices";
import moment from "moment";
import { FiSearch } from "react-icons/fi";

function HeadMyBranches() {
  const [branchList, setBranchList] = useState([]);
  const [loading, setLoading] = useState(false);
  const access_token = localStorage.getItem("gassol-head-branch-token");

  useEffect(() => {
    fetchSubBranchList(true);
  }, []);

  const fetchSubBranchList = async (load_bool) => {
    setLoading(load_bool);
    try {
      const res = await getServices(`/api/list/my/subbranch`, access_token);
      setLoading(false);
      if (res.responseCode === 200) {
        setBranchList(res.responseData);
      } else {
        setBranchList([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleBranchSearch = async (e) => {
    if (e.target.value.length > 0) {
      try {
        const res = await getServices(
          `/api/list/my/subbranch?searchkey=${e.target.value}`,
          access_token
        );
        if (res.responseCode === 200) {
          setBranchList(res.responseData);
        } else {
          setBranchList([]);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      fetchSubBranchList(false);
    }
  };

  return (
    <>
      <div className="px-6 pb-5 flex flex-col gap-8 pt-4 lg:pt-0">
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">
          <p className="text-5xl font-bold">My Branches</p>

          <div className="relative">
            <input
              type="text"
              className="py-4 pl-12 pr-4 outline-none rounded-xl w-full md:min-w-[280px] xl:min-w-[350px]"
              placeholder="Search by Branch name"
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 80px 0 rgba(0, 0, 0, 0.19)",
              }}
              onChange={handleBranchSearch}
            />
            <FiSearch className="absolute top-5 left-4 text-[#BDBDBD]" />
          </div>
        </div>

        {!loading ? (
          <div>
            {branchList.length > 0 ? (
              <Card
                className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
                style={{
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                <table className="w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {HEAD_BRANCH_LIST_HEAD.map((head) => (
                        <th
                          key={head}
                          className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-poppins text-white font-semibold uppercase"
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {branchList.map((branch, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-4">
                            <Link
                              to={`/head_office/controller_details`}
                              state={{
                                sub_branch_id: branch._id,
                                subbranchName: branch.name,
                              }}
                              className="font-poppins font-semibold flex items-center gap-2 text-sm text-black"
                            >
                              <FaRegSquareCheck className="text-lg text-[#BD3B24]" />
                              {branch.name}
                            </Link>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-poppins text-sm font-medium flex items-center gap-1 w-fit px-3 py-[2px] rounded-full `}
                            >
                              {branch.email ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {branch.phone ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {moment(branch.createdAt).format("LLL")}
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>
            ) : (
              <div className="text-center h-[50vh] flex flex-col justify-center items-center">
                <p className="font-semibold text-xl sm:text-3xl">
                  Oops! No Branch Found...
                </p>
                <p className="text-sm mt-2 ">
                  Looks like we couldn't find any branch data that match your
                  search right now.
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}

        {/* <div className="flex items-center justify-center gap-4">
      <div className="flex items-center justify-center gap-2">
        <Pagination
          count={10}
          defaultPage={Number(page_nmr)}
          siblingCount={0}
          boundaryCount={1}
          onChange={(e, page) => handlePaginationChange(e, page)}
          sx={{
            fontFamily: "Poppins",
            ".MuiPaginationItem-root": {
              fontFamily: "Poppins",
              borderRadius: "8px",
              color: "#BDBDBD",
            },
          }}
        />
      </div>
    </div> */}
      </div>
    </>
  );
}

export default HeadMyBranches;
